module.exports = __webpack_public_path__ + "img/go-past-btn2.61c33347.png";